import { render, staticRenderFns } from "./cashBackUser.vue?vue&type=template&id=605d1036&scoped=true&"
import script from "./cashBackUser.vue?vue&type=script&lang=ts&"
export * from "./cashBackUser.vue?vue&type=script&lang=ts&"
import style0 from "./cashBackUser.vue?vue&type=style&index=0&id=605d1036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d1036",
  null
  
)

component.options.__file = "cashBackUser.vue"
export default component.exports